package com.mshopsas.enterprise.aiw.scan.network.response

import com.mshopsas.enterprise.aiw.scan.data.basket.ShoppingList
import kotlinx.serialization.Serializable

@Serializable
data class HistoricDetailResponse(
    val historic: ShoppingList?
)